import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from 'src/app/services/common/common.service';
import { CollegeBatchModel } from 'src/app/models/collegeBatchModel';
import { CommonConstant } from 'src/app/constants/common-constant';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { CollegeBatchConstant } from 'src/app/constants/label-constants';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { collegeErrorPageMessage } from 'src/app/constants/error-message-constant';
interface colleges {
  id: any;
  value: string;
}
@Component({
  selector: 'app-college-batch-add-edit',
  templateUrl: './college-batch-add-edit.component.html',
  styleUrls: ['./college-batch-add-edit.component.scss']
})
export class CollegeBatchAddEditComponent {
  CollegeBatchForm: FormGroup = this.formBuilder.group({});
  collegeBatchId: number = 0;
  CollegeBatchList: any = [];
  collegeList: any = [];
  modalButton: boolean = false;
  CommonConstant: any = [];
  CollegeBatchConstant: any = [];
  isCollegeSelected: boolean = false;
  flag: boolean = false;
  errorMessage: any = []; 
  protected AllCollegelist: colleges[] = this.collegeList;
  public FilterCtrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();

  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;
  protected _onDestroy = new Subject();
  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  protected filtercolleges() {
    if (!this.AllCollegelist) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.AllCollegelist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.AllCollegelist.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.filteredData.next(this.AllCollegelist.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtercolleges();
        this.IsCollegeValid();
      });
    this.CommonConstant = CommonConstant;
    this.CollegeBatchConstant = CollegeBatchConstant;
    this.errorMessage = collegeErrorPageMessage;
    this.onInitCollageForm();
    if (this.collegeBatchId > 0) {
      this.getCollageBatchDetail(this.collegeBatchId);
    }
    else {
      this.collegeBatchId = 0;
    }
    this.spinner.show();
    this.getCollegeList();
  }

  onInitCollageForm() {
    this.CollegeBatchForm = this.formBuilder.group({
      CollegeBatchId: [0],
      CollegeId: [0],
      BatchName: ['', [Validators.required, Validators.maxLength(100)]],
      BatchYear: ['', [Validators.required, Validators.pattern(/^(20[2-9][0-9]|2099)$/)]]
    });
  }
  get collegeBatchFormControl() {
    return this.CollegeBatchForm.controls;
  }

  onCancel() {
    if (this.CollegeBatchForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.CollegeBatchForm = this.CollegeBatchForm;
    }
    else {
      this.modalService.close();
    }
  }

  getCollageBatchDetail(CollageId: number) {
    const apiUrl = this.apiUrl.apiUrl.collageBatch.GetCollegeByIdBatch.replace("{id}", CollageId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.setCollageForm(data.data[0]);
      },
      error: (err) => {
        console.log('getGetRoleById-Error', err);
      }
    });
  }

  setCollageForm(data: CollegeBatchModel) {
    this.CollegeBatchForm.setValue({
      CollegeBatchId: (data.collegeBatchId) ? data.collegeBatchId : 0,
      CollegeId: data.collegeId,
      BatchName: data.batchName,
      BatchYear: data.batchYear
    });
  }

  IsCollegeValid() {
    if (this.CollegeBatchForm.value.CollegeId == 0) {
      this.isCollegeSelected = true;
    }
    else {
      this.isCollegeSelected = false;
    }
  }

  saveCollageBatch() {
    this.modalButton = true;
    if (this.CollegeBatchForm.value.CollegeId == 0 || !this.CollegeBatchForm.valid) {
      this.isCollegeSelected = true;
      return;
    }
    this.isCollegeSelected = false;
    this.spinner.show();
    const objData: CollegeBatchModel = {
      collegeBatchId: !this.CollegeBatchForm.value.CollegeBatchId ? 0 : this.CollegeBatchForm.value.CollegeBatchId,
      collegeId: Number.parseInt(this.CollegeBatchForm.value.CollegeId),
      batchName: this.CollegeBatchForm.value.BatchName,
      batchYear: this.CollegeBatchForm.value.BatchYear,
    }
    const apiUrl = this.apiUrl.apiUrl.collageBatch.SaveCollegeBatch;
    this.CommonService.doPost(apiUrl, objData).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalButton = false;
          this.spinner.hide();
          this.modalService.close('save');
          this.toastr.success(data.message);
        }
        else {
          this.modalButton = false;
          this.spinner.hide();
          this.toastr.error(data.message);
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }

  getCollegeList() {
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeListForDropDown;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.collegeList.push({ 'id': data.data[i].collegeId, 'value': data.data[i].collegeName })
          }
          this.filtercolleges()
        }
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }
}
